export const ZENDESK_BASE_URL = "https://dcsports87.zendesk.com";
